export function routes($stateProvider) {
  $stateProvider
    .state('app.evento', {
      url: '/evento',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.evento.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Orientações',
      template: require('./directory/directory.view.html'),
      controller: 'EventoListController',
      controllerAs: 'vm',
      role: 'eventoRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "desc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.evento.details', {
      url: '/{id}',
      title: 'Orientação',
      controller: 'EventoDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'eventoRead'
    })
    .state('app.evento.new', {
      url: '/novo',
      title: 'Adicionar Orientação',
      template: require('./new/new.view.html'),
      controller: 'EventoCreateEventoController',
      controllerAs: 'vm',
      role: 'eventoCreate'
    })
    .state('app.evento.new.1', {
      template: require('./new/evento.1.form.html')
    })
    .state('app.evento.new.2', {
      template: require('./new/evento.2.form.html')
    })
    .state('app.evento.new.3', {
      template: require('./new/evento.3.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
